var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"omapi-text-select-input"},[_c('label',[_vm._v(_vm._s(_vm.label)+" "),_c('input',{attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":_vm.input},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }